export default __webpack_public_path__ + "static/media/spheres-other.4b672f40.wav";